import Cookies from "js-cookie";
import { COOKIES_TIME } from "appRedux/constants";

export const setSession = value => {
  Cookies.set("__session", value, { expires: COOKIES_TIME });
};

export const setSessionWithValue = (value, key) => {
  Cookies.set(key, value, { expires: COOKIES_TIME });
};

export const getSessionWithKey = key => {
  return Cookies.get(key);
};

export const getPinFromSession = () => {
  // set pin here
};

export const getSession = () => {
  const jwt = Cookies.get("__session");

  let session = "";
  try {
    if (jwt) {
      session = jwt;
    }
  } catch (error) {}

  return session;
};

export const clearSessionWithParams = key => {
  return Cookies.remove(key);
};

export const clearSession = () => {
  return Cookies.remove("__session");
};
